<template>
  <v-img :src="image" height="100%" style="background-size: cover;
        background-position: top center;cursor:default;">
    <v-layout class="fill-height" align-center justify-center style="background: rgba(0, 0, 0, 0.4);height: 100%;">
      <v-flex xs12 sm8 md2>
        <material-card light color="indigo" :title="$vuetify.lang.t('$vuetify.common.login')" :text="$vuetify.lang.t('$vuetify.login.input')" class="elevation-12" style="min-width:300px">
          <v-card-text>
            <v-form>
              <v-text-field @keyup.enter="onSubmitForm" v-model="loginFormData.username" :label="$vuetify.lang.t('$vuetify.user.table.name')" id="username" type="text" color="indigo" prepend-icon="mdi-face"></v-text-field>
              <v-text-field @keyup.enter="onSubmitForm" v-model="loginFormData.password" :label="$vuetify.lang.t('$vuetify.user.table.password')" id="password" type="password" color="indigo" prepend-icon="mdi-lock"></v-text-field>
            </v-form>
            <v-card-actions>
              <v-btn block
                     color="indigo_lighten_1"
                     style="color:#fff"
                     v-on:click="onSubmitForm">
                <span style="color:#fff">{{$vuetify.lang.t('$vuetify.common.login')}}</span>
              </v-btn>
            </v-card-actions>
            <!-- login-button -->
            <v-subheader style="height:2rem">
              其他登录方式
            </v-subheader>
            <v-divider></v-divider>
            <!-- other login type  -->
            <a href="javascript:void(0);" @click="qqLogin">
              <img style="height:30px;width:30px;margin: 10px 16px 0px;" :src="qqlogo">
            </a>
            <!-- qq -->
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>

    //google认证
    <v-dialogs :theme="googlecode" :dialog="GoogleVisible" @dialogSure="onSubmitAuth">
      <v-form
          ref="form"
          lazy-validation
      >
        <v-row justify="center" align="center" v-if="isauth">
          <v-col cols="12">
            <v-card>请下载google authenticator扫描下方二维码进行绑定，然后输入app上的6位动态验证码进行认证。安卓版可点击下方按钮获取二维码，IOS版可在App Store搜索下载。</v-card>
          </v-col>
        </v-row>
        <v-col v-if="isauth">
          <v-btn
              color="primary"
              class="ma-2"
              dark
              @click="GoogleApkVisible = true"
          >
            APK下载
          </v-btn>
        </v-col>
        <v-row justify="center" align="center">
<!--          <v-col cols="12">-->
            <img :src="auth.img" v-if="isauth" alt="">
<!--          </v-col>-->
        </v-row>
        <v-row justify="center" align="center" v-if="!isauth">
          <v-col cols="12">
            <v-card>请打开谷歌验证器，输入6位动态密码</v-card>
          </v-col>
        </v-row>
        <v-text-field
            v-model="auth.code"
            :label="$vuetify.lang.t('$vuetify.user.table.code')"
            placeholder="请输入6位动态密码"
        ></v-text-field>
      </v-form>
    </v-dialogs>

    <v-dialogs theme="下载地址" :dialog="GoogleApkVisible" @dialogSure="onSubmitQr">
      <v-row justify="center" align="center">
        <img :src="googleapk" width="300px" alt="">
      </v-row>
    </v-dialogs>

    //短信验证
    <v-dialogs theme="短信验证" :dialog="SmsVisible" @dialogSure="onSubmitSms">
      <v-form
          ref="form"
          lazy-validation
      >
        <v-col cols="12" class="mt-6">

          <v-text-field
              v-model="sms.tel"
              :counter="11"
              label="手机号"
              required
              color="#6cbdff"
              class="mt-4"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="mt-6">
          <!-- prepend-inner-icon="mdi-message-processing-outline" -->
          <v-row>
            <v-col cols="7">
              <v-text-field
                  v-model="sms.code"
                  :counter="6"
                  label="验证码"
                  required
                  color="#6cbdff"
                  class="mt-4"
              ></v-text-field>
            </v-col>
            <v-col cols="5" class="mt-7">
              <v-btn
                  v-show="sendAuthCode"
                  block
                  tile
                  dark
                  @click="getAuthCode"
                  color="#6cbdff"
                  class="elevation-0"
              >
                获取验证码
              </v-btn>
              <v-btn
                  v-show="!sendAuthCode"
                  dark
                  tile
                  block
                  color="#BDBDBD"
                  class="elevation-0"
              >
                {{ authTime }}秒后重新获取
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-form>
    </v-dialogs>
  </v-img>
  <!--  <el-dialog title="谷歌验证" :visible.sync="GoogleVisible">-->
  <!--    <el-form :model="form">-->
  <!--      <el-form-item label="绑定谷歌验证" :label-width="formLabelWidth">-->
  <!--        <img :src="auth.img" alt="">-->
  <!--      </el-form-item>-->
  <!--      <el-form-item label="谷歌验证码" :label-width="formLabelWidth">-->
  <!--        <el-input v-model="auth.code" autocomplete="off"></el-input>-->
  <!--      </el-form-item>-->
  <!--    </el-form>-->
  <!--    <div slot="footer" class="dialog-footer">-->
  <!--      <el-button @click="GoogleVisible = false">取 消</el-button>-->
  <!--      <el-button type="primary" @click="onSubmitAuth">确 定</el-button>-->
  <!--    </div>-->
  <!--  </el-dialog>-->

</template>

<script>
import * as systemConfig from './../../env.js'
import * as api from './../../api'
import sha1 from 'js-sha1'
import md5 from 'js-md5'
import { Notification  } from 'element-ui';
import vDialogs from './../../components/core/Dialog.vue'

// import { Dialog  } from 'element-ui';
import { aesEncrypt, encryptData, decryptData } from './../../utils/encrypt.js'
import { mapActions } from 'vuex'
import bus from './../../utils/bus.js'
import vTable from "../Gateway/components/Table";

export default {
  data() {
    return {
      dialog: false,
      sendAuthCode: true,
      googlecode: this.$vuetify.lang.t('$vuetify.user.table.googlecode'),
      smscode: this.$vuetify.lang.t('$vuetify.user.table.googlecode'),
      getcode: '获取验证码',
      authTime: 0,
      loginFormData: {
        username: '',
        password: '',
      },
      auth:{
        img: '',
        code: ''
      },
      sms:{
        code: '',
        tel: '',
      },
      isauth: false,
      GoogleVisible: false,
      GoogleApkVisible: false,
      SmsVisible: false,
      formLabelWidth: '120px',
      ConfirmPassword: '',
      reg_username: '',
      reg_password: '',
      image: require('./city-profile.jpg'),
      qqlogo: require('../../../public/static/img/logos/qq.png'),
      googleapk: require('../../../public/static/img/googleapk.png')
    }
  },
  mounted(){
    this.$nextTick(()=>{
    })
  },
  components: {
    vDialogs
  },
  methods: {
    onRegisterForm: function(e) {
    },
    onSubmitForm(e) {
      e.preventDefault();
      // this.GoogleVisible = true

      if(this.loginFormData.username == ''||this.loginFormData.password == ''){
        Notification({
          type: 'error',
          message: this.$vuetify.lang.t('$vuetify.login.nullTip')
        });
      }else{
        const postData = {
          username: this.loginFormData.username,
          password: sha1(md5(this.loginFormData.password)),
        }
        this.$http.post(api.default.auth.loginUrl, postData).then(resp => {
          let res = []
          for(let i in resp){
            res.push(resp[i])
          }
          if (resp){
            if (resp.data.uid){
              var authUser = this.loginFormData.username
              window.sessionStorage.setItem('authUser', authUser);
              window.sessionStorage.setItem('name', res[1].name);
              window.sessionStorage.setItem('contact', res[1].contact);
              window.sessionStorage.setItem('type', res[1].type);
              window.sessionStorage.setItem('shop_id', res[1].shop_id);
              window.sessionStorage.setItem('group_id', res[1].group_id);
              this.$router.push('/dashboard');
              return
            }
            this.auth.img = resp.data.qrcode
            this.isauth = resp.data.isauth
            this.GoogleVisible = true
          }
        }).finally(resp => {

        })
      }
    },
    onSubmitQr(params){
      return this.GoogleApkVisible = false;
    },
    onSubmitAuth(params){
      if(!params) {
        return this.GoogleVisible = !this.GoogleVisible;
      }
      this.$http.post(api.default.auth.authloginUrl, this.auth).then(resp => {
        let res = []
        for(let i in resp){
          res.push(resp[i])
        }
        var authUser = this.loginFormData.username
        window.sessionStorage.setItem('authUser', authUser);
        window.sessionStorage.setItem('name', res[1].name);
        window.sessionStorage.setItem('contact', res[1].contact);
        window.sessionStorage.setItem('type', res[1].type);
        window.sessionStorage.setItem('shop_id', res[1].shop_id);
        window.sessionStorage.setItem('group_id', res[1].group_id);
        this.$router.push('/dashboard');
      }).finally(resp => {

      })
    },
    onSubmitSms(params) {

    },
    getAuthCode(){
      console.log(111)
    },
    qqLogin(){
      this.$http.post("/captiveportal/api/getQqLogin").then(resp => {
        if(resp.errno !== 0)
          return false
        window.location.href=resp.data.url
      }).finally(resp => {

      })
    }
  }
}
</script>

<style lang="scss">
.button-container {
  left: 0;
  opacity: 1;
  visibility: visible;
  transition: .3s ease;
}
/* Footer */

.footer {
  margin: 10px 0 0;
  color: #d3d3d3;
  font-size: 18px;
  font-weight: 300;
  text-align: center;
  a {
    color: inherit;
    text-decoration: none;
    transition: .3s ease;
    &:hover {
      color: darken(#d3d3d3, 10%);
    }
  }
  .v-menu__content {
    top: 227px!important;
    left: 464px!important;
  }
}
</style>
